export type GetIfDefinitionReviewDiffsRequest = {
  dfnSetVerNum: string;
  pjtId: string;
  compareTargetType:
    | "PREV_REVIEW"
    | "LATEST_STG"
    | "LATEST_PRD"
    | "PJ_START_STG"
    | "PJ_START_PRD";
  mode: "review" | "request-approval";
};
